import { Box, Typography } from '@mui/material';
import { Loading } from './Loading';

export function PageLoading({ loadingMessage = 'Loading...' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        gap: '5px',
      }}
    >
      <Loading />
      <Typography>{loadingMessage}</Typography>
    </Box>
  );
}
